import React from 'react';
import { Box } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { AdminLegendVariant } from '@pharmaplan/common';
import styles from './styles';
import legendStyles from '../AdminLegend/styles';
import AdminBookedLegendItem, { IAdminBookedLegendItem } from './AdminBookedLegendItem/AdminBookedLegendItem';

interface IAdminBookedLegend {
  items: Array<Omit<IAdminBookedLegendItem, 'isRow'>>;
  isRow: boolean;
  customClass?: Record<string, unknown>;
}

const AdminBookedLegend = ({ items, isRow, customClass }: IAdminBookedLegend) =>
  (
    <Box
      sx={[
        legendStyles.legendContainerBg(AdminLegendVariant.booked),
        styles.container,
        customClass as SystemStyleObject,
      ]}
    >
      <Box sx={[styles.itemsContainer, isRow && styles.verticalItemsContainer]}>
        {items.map((item) =>
          (
            <AdminBookedLegendItem
              key={item.labelKey}
              labelKey={item.labelKey}
              replacementType={item.replacementType}
              totalHrs={item.totalHrs}
              totalCount={item.totalCount}
              isRow={isRow}
            />
          ))}
      </Box>
    </Box>
  );

export default AdminBookedLegend;
